import type { ExtractPropTypes, PropType } from "vue";
import type { UiTypes } from "various-ui";

export const DefaultSelectorPropsOption = {
    size: { type: String as PropType<"default" | "middle">, default: "default" },
    disabled: { type: Array as PropType<string[]>, default: [] },
    modelValue: { type: String, required: true },
    candidates: { type: Array as PropType<UiTypes.candidate[]>, required: true },
} as const;

export type DefaultSelectorProps = ExtractPropTypes<typeof DefaultSelectorPropsOption>;

export const DefaultSelectorEmits = {
    "update:modelValue": (_context: string) => true,
    "change": (_context: string) => true,
};
